import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchNotificationById, updateNotification } from "../notificationsApi";
import { Button, TextField, Paper, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import config from "../config";
import Swal from 'sweetalert2';

export default function EditNotification() {
  const { id } = useParams();
  const [form, setForm] = useState({
    Title: "",
    Subtitle: "",
    Message: "",
    Type: "",
    Image: ""
  });
  const [imagePreview, setImagePreview] = useState("");
    const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchNotificationById(id).then(noti => {
      setForm(noti);
      setImagePreview(noti.Image || "");
    });
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setForm((prev) => ({ ...prev, Image: reader.result }));
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateNotification(id, form);
      await Swal.fire(t('success'), t('NotificationUpdatedSuccess') || 'Notification updated successfully!', 'success');
      navigate("/admin/notifications");
    } catch (err) {
      await Swal.fire(t('error'), t('NotificationUpdatedError') || 'Failed to update notification.', 'error');
    }
  };

  return (
      <Paper sx={{ p: 2, maxWidth: 500, mx: "auto" }}>
        <Typography variant="h6" gutterBottom>{t('EditNotification')}</Typography>
        <form onSubmit={handleSubmit}>
          <TextField fullWidth label={t('NotificationTitle')} name="Title" value={form.Title} onChange={handleChange} margin="normal" required />
          <TextField fullWidth label={t('NotificationSubtitle')} name="Subtitle" value={form.Subtitle} onChange={handleChange} margin="normal" />
          <TextField
            fullWidth
            label={t('NotificationMessage')}
            name="Message"
            value={form.Message}
            onChange={handleChange}
            margin="normal"
            required
            multiline
            minRows={3}
            maxRows={Infinity}
            inputProps={{ maxLength: undefined }}
            sx={{
              '& .MuiInputBase-root': {
                alignItems: 'flex-start',
              },
              '& .MuiInputBase-input': {
                overflow: 'auto',
                resize: 'vertical',
              },
            }}
          />          
          <TextField fullWidth label={t('NotificationType')} name="Type" value={form.Type} onChange={handleChange} margin="normal" required />
          <Button
            variant="outlined"
            component="label"
            fullWidth
            sx={{ mt: 2, mb: 1, display: 'block' }}
          >
            {t('NotificationImage')}
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleImageChange}
            />
          </Button>
          {imagePreview && (
            <img
              src={imagePreview.startsWith('http')
                ? imagePreview
                : `${config.API_BASE_URL}/${imagePreview.replace(/^\//, '')}`}
              alt="Preview"
              style={{ maxWidth: 200, display: 'block', marginBottom: 16 }}
            />
          )}
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>{t('Update')}</Button>
        </form>
      </Paper>
  );
}
